export const logWarning = (message: string) => {
  console.log(`%c${message}`, 'padding: 10px; background: red; color: white;');
};
